export function monthName(month) {
    switch(month) {
        case 1:
            return "Januar";
        case 2:
            return "Februar";
        case 3:
            return "März";
        case 4:
            return "April";
        case 5:
            return "Mai";
        case 6:
            return "Juni";
        case 7:
            return "Juli";
        case 8:
            return "August";
        case 9:
            return "September";
        case 10:
            return "Oktober";
        case 11:
            return "November";
        case 12:
            return "Dezember";
        default: 
            return 'monthname';
    }
}
export function dayName(day) {
    switch(day) {
        case 1:
            return "Montag";
        case 2:
            return "Dienstag";
        case 3:
            return "Mittwoch";
        case 4:
            return "Donnerstag";
        case 5:
            return "Freitag";
        case 6:
            return "Samstag";
        case 7:
            return "Sonntag";
        default: 
            return 'dayname';
    }
}


export function passedTime(dateIn) {
		
    const now = Date.now();
    const timestamp = new Date(dateIn);

    const diff_ms 	    = Math.max(0, now - timestamp);
    const diff_s        = diff_ms/1000;
    const diff_m        = diff_s/60;
    const diff_h        = diff_m/60;
    const diff_d        = diff_h/24;
    const diff_w        = diff_d/7;

    let value = diff_ms;
    let unit = 'ms';

    if(diff_w >= 1) {
        value = Math.floor(diff_w);
        unit = value > 1 ? 'Wochen' : 'Woche';
    } else if(diff_d > 1) {
        value = Math.floor(diff_d);
        unit = value > 1 ? 'Tagen' : 'Tag';
    } else if(diff_h > 1) {
        value = Math.floor(diff_h);
        unit = value > 1 ? 'Stunden' : 'Stunde'
    } else if(diff_m > 1) {
        value = Math.floor(diff_m);
        unit = value > 1 ? 'Minuten' : 'Minute';
    } else if(diff_s > 1) {
        value = Math.floor(diff_s);
        unit = value > 1 ? 'Sekunden' : 'Sekunde';
    }

    return `vor ${value} ${unit}`;
}

export function formatDateTime(dateIn) {
		
    const date = new Date(dateIn);

    const parts = {
        d: date.getDate(),
        m: date.getMonth() + 1,
        Y: date.getFullYear(),
        H: date.getHours(),
        i: date.getMinutes()
    }

    for(let key in parts) {
        if(key === 'Y') continue;
        parts[key] = String(parts[key]).padStart(2, '0');
    }
    

    return `${parts.d}.${parts.m}.${parts.Y} ${parts.H}:${parts.i}`; 

}


// WEBPACK FOOTER //
// ./src/date3.js